import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const DeliveryIcon = ({ width = "16px", height = "16px" }) =>
  websiteName === "bricostore" ? (
    // Material UI icons "LocalShippingOutlined" (24x24, Apache-2.0). Color via currentColor.
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5 1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 16"
      width={width}
      height={height}
    >
      <path d="M8 8H2v1h6V8ZM6 5.5H1v1h5v-1Z" />
      <path d="m14.96 8.3-1.5-3.5a.5.5 0 0 0-.46-.3h-1.5v-1A.5.5 0 0 0 11 3H3v1h7.5v6.28a2 2 0 0 0-.93 1.22H6.43a2 2 0 1 0 0 1h3.14a1.99 1.99 0 0 0 3.86 0h1.07a.5.5 0 0 0 .5-.5V8.5a.5.5 0 0 0-.04-.2ZM4.5 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-7.5h1.17L13.74 8H11.5V5.5Zm0 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.5-1.5h-.57A2 2 0 0 0 11.5 10V9H14v2.5Z" />
    </svg>
  );

export default DeliveryIcon;
